import * as PassengersStyles from './components/Passengers.css';
import * as PassengerStyles from './components/Passenger/Passenger.css';

export default {
	PassengersStyles,
	PassengerStyles
};
